<template>
  <div id="chartControls" :expanded="expanded">
    <div v-if="activeField === null" class="chart-controls__bubbles">
      <div class="chart-controls__collapsed" @click="expanded = true">
        <div class="chart-controls__bubble ellipsis">
          <div class="chart-controls__bubble-content" />
        </div>
      </div>
      <div class="chart-controls__expanded">
        <div class="chart-controls__bubble chart-close" @click="expanded = false">
          <div class="chart-controls__bubble-content" />
        </div>
        <div
          v-for="field in fields"
          :key="field.key"
          v-tooltip="field.label"
          class="chart-controls__bubble"
          :class="field.key"
          @click="activeField = field.key"
        >
          <div class="chart-controls__bubble-content" />
          <!-- <abbr :title="field.label"><div class="chart-controls__bubble-content" /></abbr> -->
        </div>
      </div>
    </div>
    <controls-content v-model="activeField" :mode="mode" :chart-data="chartData" />
  </div>
</template>

<script>
import ControlsContent from './ControlsContent.vue'

export default {
  components: { ControlsContent },
  props: ['mode', 'chartData'],
  data() {
    return {
      fields: [
        {key: 'chart-settings', label: "Settings"},
        {key: 'chart-disclaimer', label: 'Notes & Disclaimers'},
        {key: 'chart-download', label: 'Downloads'},
        {key: 'chart-share', label: 'Share'}
      ],
      activeField: null,
      expanded: false,
    }
  },
}
</script>

<style lang="stylus" scoped>
$bubble-side = 45px
$bubble-side-small = 35px

#chartControls
  &:not([expanded])
    .chart-controls__collapsed
      visibility: visible
      border-radius: 50%
      box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.05)

    .chart-controls__expanded
      padding-top: 0

      .chart-controls__bubble
        top: 0
        margin-bottom: 0
        box-shadow: none

.chart-controls__bubbles
  position: relative
  min-width: $bubble-side
  min-height: $bubble-side

  .mobile &
    min-width: $bubble-side-small
    max-width: $bubble-side-small

.chart-controls__collapsed
  position: absolute
  z-index: 11
  visibility: hidden
  width: $bubble-side
  height: $bubble-side

  .mobile &
    width: $bubble-side-small
    height: $bubble-side-small

.chart-controls__expanded
  position: relative
  visibility: visible

.chart-controls__bubble
  $margin-bottom = 10px
  position: absolute
  top: 0
  left: 0
  z-index: 10
  display: flex
  justify-content: center
  align-items: center
  width: $bubble-side
  height: $bubble-side
  border: 1px solid $gray
  border-radius: 50%
  background-color: #fff
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.05)
  cursor: pointer
  transition: margin-bottom 0.24s ease-in-out, top 0.24s ease-in-out, box-shadow 0.24s ease-in-out

  .mobile &
    width: $bubble-side-small
    height: $bubble-side-small

  for $num in (2..5)
    &:nth-child({$num})
      top: (($bubble-side + $margin-bottom) * ($num - 1))
      z-index: (10 - $num)

      .mobile &
        top: (($bubble-side-small + $margin-bottom) * ($num - 1))

        +m-breakpoint(landscape)
          top: (($bubble-side-small + $margin-bottom / 2) * ($num - 1))

  &:last-child
    margin-bottom: 0

  &.ellipsis .chart-controls__bubble-content
    m-icon("dots", 35)

    .mobile &
      m-icon("dots", 26)

      +m-breakpoint(landscape)
        m-icon("dots", 13)

  $bubbles = "close", "settings", "disclaimer", "download", "share"

  for $bubble in $bubbles
    &.chart-{$bubble} .chart-controls__bubble-content
      m-icon("controls-" + $bubble, 30)

      .mobile &
        m-icon("controls-" + $bubble, 25)

        +m-breakpoint(landscape)
          m-icon("controls-" + $bubble, 12)

.chart-controls__bubble-content
  background-position: center
  background-size: contain
  background-repeat: no-repeat
</style>
